export const ExcelDebtTypes = {
  ADD_EXCEL_DEBT: "ADD_EXCEL_DEBT",
};
